import * as Sentry from '@sentry/browser'
import { object, string } from 'yup'

import { ActionType, PageName } from 'generated/types'
import { sendToSentry } from 'utils/errors'
import { FlowRoute } from 'utils/FlowProvider/types'

export type FormValues = {
  fundingSource: string
}

export const validationSchema = object().shape({
  fundingSource: string().required('Please select an account as your funding source.'),
})

export const handleSubmit = (_, { props, ...ownProps }) => {
  const linkedSubaccountId = props.selectedAccountId
  // Disabling ESLint for this line for no reason other than the code existed like this before this ESLint rule went into effect.
  // If you're here from the future, please resolve this ESLint error!
  // eslint-disable-next-line no-unsafe-optional-chaining
  const { financialInstitution } = props.location?.state
  const linkedSubaccounts = props.location?.state?.linkedSubaccounts?.filter(
    account => account.id === linkedSubaccountId,
  )

  ownProps.setSubmitting(true)
  Sentry.addBreadcrumb({
    message: 'User is attempting to link primary funding source from /choose-funding-source page.',
  })

  return props
    .setPrimaryFundingSource(linkedSubaccountId)
    .then(() => {
      props.trackOptimizely('funding_source.linked')

      const locationState = { financialInstitution, linkedSubaccounts }
      props.isDynamicFunnelEnabled
        ? props.routeToPage(PageName.ChooseFundingSource, ActionType.Continue, locationState)
        : props.route({ from: FlowRoute.ChooseFundingSource, action: 'continue', locationState })
    })
    .catch(error => {
      ownProps.setSubmitting(false)
      sendToSentry(error)
    })
}

export const mapPropsToValues = props => {
  const values = {
    fundingSource: '',
  }

  return values
}
